<div class="modal-header border-0 modal-header border-0 pb-0 p-3">
    <h3 class="fw-600 f-16">Security Check</h3>
    <!-- <button type="button" class="btn-close" aria-hidden="true" (click)="closeSecurityCheckModal()"></button> -->
</div>
<ng-container *ngIf="!verifiedCheck">
    <div class="modal-body border-0 text-center pt-0 p-3">
        <p class="security-check-content w-100 f-14">Guess words and characters seen in image below.
            Can’t read this? <a href="javascript:void(0)" class="cpt-btn reload" (click)="createCaptcha()">Try
                another</a>.</p>
        <div class="captcha-container {{ config.cssClass}}">
            <div class="captcha-canvas-container">
                <canvas id="captcahCanvas" width="260" height="80"></canvas>
                <div class="captcha-actions captcha-action-btns">
                    <!-- <div class="form-control p-2">
                        <a href="javascript:void(0)" class="cpt-btn" (click)="playCaptcha()"><i
                                class="fas fa-volume-up"></i></a>
                    </div> -->
                    <div class="form-control p-2" style="margin-left:10px ;">
                        <a href="javascript:void(0)" class="cpt-btn reload" (click)="createCaptcha()"><i
                                class="fas fa-sync"></i></a>
                    </div>
                </div>
            </div>
            <div class="captcha-actions mt-3">
                <div class="row">
                    <div class="col-12 text-start wdt-100 mb-1">
                        <input type="text" [ngClass]="captchaCheckError !== '' ? 'input-invalid' : ''"
                            placeholder="Enter Code" [(ngModel)]="captch_input" class="form-control" (change)="checkCaptcha()"/>
                        <span class="text-danger fs-7">{{captchaCheckError}}</span>
                    </div>
                    <!-- <div class="col-4 wdt-100">
                        <button class="sec-btn font-size-18 fw-700 text-black ng-star-inserted w-100" [disabled]="captch_input == ''"
                        (click)="checkCaptcha()" type="button">Submit</button>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="modal-footer border-0">

    </div> -->
</ng-container>
<ng-container *ngIf="verifiedCheck">
    <div class="modal-body border-0">
        <div class="verified-section h-auto">
            <img src="assets/images/Verified.svg">
        </div>
    </div>
</ng-container>
